// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5033a87c","977":"501f43ce"}[chunkId] + ".chunk.js";
};